import React from 'react'
import { DataTable, Button, Table } from '@arnsbogroup/react-voicearchive'
import messages from './messages'
import { FormattedMessage, useIntl } from 'react-intl'
import { Span } from 'components/datatable'

const ReportResults = ({
    loading = false,
    selectedOrderIds = [],
    onOrderSelected = () => {},
    entries = [],
    onOrdersSend = () => {}
}) => {
    const { formatMessage } = useIntl()

    const getHead = () => {
        return {
            orderNumber: { label: formatMessage(messages.orderNumber) },
            date: { label: formatMessage(messages.date) },
            customerNumber: { label: formatMessage(messages.customerNumber) },
            customerName: { label: formatMessage(messages.customerName) },
            heading: { label: formatMessage(messages.heading) },
            currency: { label: formatMessage(messages.currency) },
        }
    }
    
    const getBody = () => {
        return {
            orderNumber: Span,
            date: Span,
            customerNumber: (entry) => <Span>{entry?.customer?.customerNumber}</Span>,
            customerName: (entry) => <Span>{entry?.recipient?.name}</Span>,
            heading: (entry) => <Span>{entry?.notes?.heading}</Span>,
            currency: Span,
        }
    }
    

    return (
        <div className="w-full">
            {!!selectedOrderIds.length &&
                <div className='m-2'>
                    <Button
                        disabled={loading}
                        onClick={() => onOrdersSend(selectedOrderIds)}
                        size="base"
                    >
                        <FormattedMessage {...messages.sendOrders} />
                    </Button>
                </div>
            }
            <div className="grow overflow-y-scroll">
                <DataTable
                    noDataMessage={formatMessage(messages.noData)}
                    rowSelectionKey="orderNumber"
                    rowsSelected={selectedOrderIds}
                    onRowSelected={(id) => onOrderSelected(id)}
                    head={getHead()}
                    body={getBody()}
                    entries={entries}
                />
            </div>
        </div>
    )
}

export default ReportResults
